import { createStore as _createStore } from 'vuex'
import producer from './producer'

export function createStore (router) {
  return _createStore({
    modules: {
      producer
    },
    state: {
      get route() {
        return router.currentRoute.value
      }
    },
    mutations: {},
    actions: {}
  });
}
